import { render, staticRenderFns } from "./JobChat.htm?vue&type=template&id=4950c842&scoped=true&"
import script from "./JobChat.ts?vue&type=script&lang=js&"
export * from "./JobChat.ts?vue&type=script&lang=js&"
import style0 from "./JobChat.scss?vue&type=style&index=0&id=4950c842&lang=scss&scoped=true&"
import style1 from "./JobChatLayout.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4950c842",
  null
  
)

export default component.exports